import moment from "moment";
import { logDataHelperFunctions } from "../logdata-helper";

const dateFilter = (filterLocalDateAtMidnight, cellValue) => {
  const dateAsString = moment(1000000 * cellValue).format("DD/MM/YYYY");

  if (dateAsString == null) {
    return 0;
  }

  // In the example application, dates are stored as dd/mm/yyyy
  // We create a Date object for comparison against the filter date
  const dateParts = dateAsString.split("/");
  const year = Number(dateParts[2]);
  const month = Number(dateParts[1]) - 1;
  const day = Number(dateParts[0]);
  const cellDate = new Date(year, month, day);

  // Now that both parameters are Date objects, we can compare

  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
};

const aggridHelpers = {
  dateFilter,
};

const COLUMN_WIDTHS = {
  small: 130,
  medium: 170,
  large: 200,
};

const getReportColumns = (reportColumns) => {
  if (reportColumns) {
    try {
      let parsedData = JSON.parse(reportColumns);
      return parsedData;
    } catch (e) {
      return logDataHelperFunctions.sampleReportColumns;
    }
  } else {
    return logDataHelperFunctions.sampleReportColumns;
  }
};

const deriveConfigurationWeldParams = ({
  weldParams,
  view,
  jobNumbers,
  statusCalculationMethod,
}) => {
  console.log(
    {
      weldParams,
      view,
      jobNumbers,
      statusCalculationMethod,
    },
    "deriveConfigurationWeldParams - payload"
  );

  const uniqueJobNumbers = [...new Set(jobNumbers)];

  if (uniqueJobNumbers?.length > 1) {
    return {
      showRedCircle: true,
      hideStatus: false,
    };
  } else if (uniqueJobNumbers.length == 1) {
    const calculationLevel = weldParams?.find(
      (ite) => ite.job_number == uniqueJobNumbers[0]
    )?.calculation_level;

    console.log(
      "deriveConfigurationWeldParams - Calculation Level:",
      calculationLevel
    );

    switch (calculationLevel) {
      case "pass_level": {
        console.log("deriveConfigurationWeldParams - Inside pass_level case");
        switch (view) {
          case "Pass":
          case "Zone":
          case "Tilt": {
            console.log(
              "deriveConfigurationWeldParams - Inside Pass/Zone/Tilt view case"
            );
            return {
              hideStatus: false,
              showRedCircle: true,
              calculation_level: calculationLevel,
            };
          }
          case "Pass_tlog":
          case "Zone_tlog":
          case "Tilt_tlog": {
            console.log(
              "deriveConfigurationWeldParams - Inside Pass_tlog/Zone_tlog/Tilt_tlog view case"
            );
            switch (statusCalculationMethod) {
              case "Instantaneous": {
                return {
                  hideStatus: false,
                  showRedCircle: true,
                  hideHeaderLimits: false,
                  calculation_level: calculationLevel,
                };
              }
              default: {
                return {
                  hideStatus: true,
                  showRedCircle: false,
                  hideHeaderLimits: true,
                  calculation_level: calculationLevel,
                };
              }
            }
          }
          default: {
            console.log(
              "deriveConfigurationWeldParams - No matching view case in pass_level"
            );
          }
        }
        break;
      }
      case "zone_level": {
        console.log("deriveConfigurationWeldParams - Inside zone_level case");
        switch (view) {
          case "Pass":
          case "Tilt": {
            console.log(
              "deriveConfigurationWeldParams - Inside Pass/Tilt view case"
            );
            switch (statusCalculationMethod) {
              case "Instantaneous":
              case "Average Zone": {
                console.log(
                  "deriveConfigurationWeldParams - Inside Instantaneous/Average Zone case"
                );
                return {
                  hideStatus: true,
                  showRedCircle: false,
                  calculation_level: calculationLevel,
                };
              }
              default: {
                console.log(
                  "deriveConfigurationWeldParams - No matching statusCalculationMethod in Pass/Tilt view"
                );
              }
            }
            break;
          }
          case "Zone": {
            console.log(
              "deriveConfigurationWeldParams - Inside Zone view case"
            );
            switch (statusCalculationMethod) {
              case "Instantaneous":
              case "Average Zone": {
                console.log(
                  "deriveConfigurationWeldParams - Inside Instantaneous/Average Zone case for Zone view"
                );
                return {
                  hideStatus: false,
                  showRedCircle: true,
                  calculation_level: calculationLevel,
                };
              }
              default: {
                console.log(
                  "deriveConfigurationWeldParams - No matching statusCalculationMethod in Zone view"
                );
              }
            }
            break;
          }

          case "Pass_tlog":
          case "Tilt_tlog": {
            console.log(
              "deriveConfigurationWeldParams - Inside Pass_tlog/Zone_tlog/Tilt_tlog view case"
            );
            switch (statusCalculationMethod) {
              case "Instantaneous": {
                return {
                  hideStatus: false,
                  showRedCircle: true,
                  hideHeaderLimits: true,
                  calculation_level: calculationLevel,
                };
              }
              default: {
                console.log(
                  "deriveConfigurationWeldParams - Inside Instantaneous/Average Zone case for Pass_tlog/Tilt_tlog view"
                );

                return {
                  hideStatus: true,
                  showRedCircle: false,
                  hideHeaderLimits: true,
                  calculation_level: calculationLevel,
                };
              }
            }
          }

          case "Zone_tlog": {
            console.log(
              "deriveConfigurationWeldParams - Inside Zone_tlog view case"
            );
            switch (statusCalculationMethod) {
              case "Instantaneous": {
                return {
                  hideStatus: false,
                  showRedCircle: true,
                  hideHeaderLimits: false,
                  calculation_level: calculationLevel,
                };
              }
              default: {
                console.log(
                  "deriveConfigurationWeldParams - Inside Instantaneous/Average Zone case for Pass_tlog/Tilt_tlog view"
                );

                return {
                  hideStatus: true,
                  showRedCircle: false,
                  hideHeaderLimits: true,
                  calculation_level: calculationLevel,
                };
              }
            }
          }

          default: {
            console.log(
              "deriveConfigurationWeldParams - No matching view case in zone_level"
            );
          }
        }
        break;
      }
      default: {
        console.log(
          "deriveConfigurationWeldParams - No matching calculation level"
        );
        return {
          showRedCircle: true,
          hideStatus: false,
        };
      }
    }
  } else {
    console.log("deriveConfigurationWeldParams - No unique job numbers found");
    return {
      hideStatus: false,
      showRedCircle: true,
      calculation_level: "pass_level",
    };
  }
};

export {
  aggridHelpers,
  COLUMN_WIDTHS,
  getReportColumns,
  deriveConfigurationWeldParams,
};
